var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44538 9C6.01801 9 5.65383 8.85296 5.35285 8.55889C5.05189 8.26481 5.00005 8.07416 5.00005 7.65658V1.50861C5.00005 1.09103 5.05189 0.735204 5.35285 0.441123C5.65383 0.147041 6.01801 0 6.44538 0H12.4561C12.8834 0 13.2476 0.147041 13.5486 0.441123C13.8496 0.735204 14.0001 1.09103 14.0001 1.50861V7.65658C14.0001 8.07416 13.8496 8.26481 13.5486 8.55889C13.2476 8.85296 12.8834 9 12.4561 9H6.44538ZM7.00005 7H12.0001V2H7.00005V7ZM3.044 12.5C2.61663 12.5 2.25245 12.353 1.95147 12.0589C1.65049 11.7648 1.5 11.409 1.5 10.9914V4L3.5 3.5V10C3.5 10.2761 3.72386 10.5 4 10.5H10.5L10 12.5H3.044Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboard);
export default __webpack_public_path__ + "static/media/copy-clipboard.89b6b000.svg";
export { ForwardRef as ReactComponent };